import React from 'react';
import styles from './RoleSettingTable.module.scss';
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Chip,
	IconButton,
} from '@material-ui/core';
import { connect } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { openModal } from '../../../../redux/modals/action';

const RoleSettingTable = (props) => {
	const { roles, openModal, setRoleSelected, openDeleteRolesConfirmation } =
		props;

	const handleEditRole = (roleId) => {
		openModal('addRole');
		setRoleSelected(roleId);
	};
	const handleDeleteRole = (roleId) => {
		openDeleteRolesConfirmation(roleId);
	};

	return (
		<div>
			<TableContainer
				component={Paper}
				className={styles.role_setting_table}
			>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Roles</TableCell>
							<TableCell></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{roles?.map((item, index) => (
							<TableRow key={index}>
								<TableCell>
									<Chip
										label={item.roleName}
										className={styles.role_chip}
										color='primary'
										style={{
											backgroundColor: `${item.roleColor}`,
										}}
									/>
								</TableCell>
								<TableCell align='right'>
									<IconButton
										aria-label='edit'
										onClick={() =>
											handleEditRole(item.roleId)
										}
									>
										<EditIcon
											className={styles.edit_icon}
										/>
									</IconButton>
									<IconButton
										aria-label='delete'
										onClick={() =>
											handleDeleteRole(item.roleId)
										}
									>
										<DeleteIcon
											className={styles.delete_icon}
										/>
									</IconButton>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	);
};

const mapStateToProps = (state) => ({
	roles: state.userManagement.roles,
});

export default connect(mapStateToProps, { openModal })(RoleSettingTable);
